<template>
  <div class="w-full h-full">
    <el-tree
      ref="cockpitTreeRef"
      class="w-full h-full bg-transparent text-hex-$cockpitTreeTextColor tree__organizaiton"
      :data="treeData"
      :node-key="treeOptions.nodeKey"
      :highlight-current="treeOptions.highlightCurrent"
      :expand-on-click-node="treeOptions.expandOnClickNode"
      :accordion="treeOptions.accordion"
      :props="treeOptions.props"
      :default-expand-all="true"
    >
      <div
        slot-scope="{ node }"
        class="flex flex-1 h-28px items-center justify-between overflow-hidden"
        :class="[`node__level${node.level}`]"
      >
        <div
          class="flex items-center pr-20px w-full"
          :class="node.level !== 1 ? 'max-w-1/2 min-w-1/4' : 'w-full'"
          @click="nodeClick(node.data)"
        >
          <div
            class="text-hex-$cockpitTreeTextColor w-full truncate cockpit-node__label"
            :title="node.label"
          >
            {{ node.data.label }}
            <div class="text-right float-right" v-if="node.level === 1">
              {{ node.data.allPerson ? node.data.allPerson : 0 }}人
            </div>
          </div>
        </div>
        <div v-if="node.data.tagCode" class="flex-1 flex">
          <div class="w-full flex justify-end">
            <slot class="" name="btns" :node="node"></slot>
          </div>
        </div>
        <div
          class="hidden absolute hidden true-node__item--highlight"
          :class="
            node.data.tagCode === 3
              ? 'h-[calc(100%-4px)] top-2px w-94/100 left-3/100 rounded-4px'
              : 'h-full top-0 w-full left-0 rounded-0'
          "
        ></div>
      </div>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: 'floorPeopleTree',
  props: {
    // 树数据
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 树配置
    treeOptions: {
      type: Object,
      default: () => {
        // 部门和人员同级默认配置
        return {
          props: { children: 'childen', label: 'name', isLeaf: 'leaf' },
          nodeKey: 'keyId', // 联合key
          highlightCurrent: true,
          expandOnClickNode: false,
          accordion: false,
        }
      },
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    // 树点击事件
    nodeClick(...args) {
      this.$emit('nodeClick', ...args)
    },
  },
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 8px;
  background-color: var(--cockpitScrollbar);
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: var(--cockpitScrollbarThumbBg);
}

::v-deep {
  div.el-loading-mask {
    background-color: transparent !important;
  }
  .el-tree-node__content {
    position: relative;
    height: 32px;
    color: var(--cockpitTreeTextColor);
    & > .el-tree-node__expand-icon {
      padding: 6px 2px;
    }
  }
  // 下拉后文字颜色
  .is-expanded > div:first-of-type > div[class*='node__level'] .cockpit-node__label {
    color: var(--cockpitExpandTextColor) !important;
    transition: all 0.4s;
  }
  // 树一级样式
  .el-tree > .el-tree-node {
    .node__level1 {
      font-size: 16px;
      padding: 0 30px 0 20px;
      height: 36px;
      box-sizing: border-box;
      border-radius: 2px;
      border: 1px solid var(--cockpitFirstBorderColor);
      box-shadow: 0px 6px 4px 0px var(--cockpitShadowColor);
    }
    & > .el-tree-node__content {
      position: relative;
      height: fit-content;
      margin-bottom: 10px;
    }
    & > .el-icon-caret-right:before {
      font-size: 16px;
    }
    & > .el-tree-node__content > .el-tree-node__expand-icon.el-icon-caret-right,
    & > .el-tree-node__content > .expanded.el-tree-node__expand-icon.el-icon-caret-right {
      position: absolute;
      right: 4px;
      &::before {
        content: '\e6df';
        background: none;
        transition: all 0.4s;
      }
    }
    & > .el-tree-node__content > .el-tree-node__expand-icon.el-icon-caret-right {
      &::before {
      }
    }
    & > .el-tree-node__content > .expanded.el-tree-node__expand-icon.el-icon-caret-right {
      &::before {
        color: var(--cockpitExpandTextColor);
      }
    }
    & > .el-tree-node__children[role='group'] {
      border: 1px solid transparent;
    }
    &.is-expanded > .el-tree-node__children[role='group'] {
      border: 1px solid var(--cockpitSecondBorderColor);
      margin-bottom: 10px;
    }
  }
  // 树非一级样式
  .el-tree {
    .el-tree-node__expand-icon,
    .el-tree-node__label {
      color: var(--cockpitTreeTextColor);
    }
    .el-tree-node__expand-icon.is-leaf {
      color: transparent;
    }
    &.el-tree--highlight-current .el-tree-node.is-current {
      & > div.el-tree-node__content {
        position: relative;
        background-color: transparent;
        .true-node__item--highlight {
          z-index: -1;
          background: var(--cockpitCurrentBg);
          display: block;
        }
      }
    }
    .el-tree-node:focus > .el-tree-node__content,
    .el-tree-node:focus,
    .el-tree-node__content:hover,
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: transparent;
    }
    .el-tree-node__expand-icon.expanded {
    }
    //有子节点 且未展开
    .el-icon-caret-right:before,
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      transition: all 0.4s;
      font-size: 18px;
    }
    //有子节点 且已展开
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      color: var(--cockpitExpandTextColor);
    }
    .el-tree-node:focus > .el-tree-node__content,
    .el-tree-node:focus,
    .el-tree-node__content:hover,
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: transparent;
    }
    .el-tree-node__expand-icon.expanded {
    }
    //有子节点 且未展开
    .el-icon-caret-right:before,
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      transition: all 0.4s;
      font-size: 18px;
      display: block;
      font-size: 16px;
    }
    //有子节点 且已展开
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
    }
  }
}
</style>
